import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MapService } from 'src/app/core/services/map.service';
import { KeyboardActionsService } from 'src/app/core/services/keyboard-actions.service';
import { PluginListenerHandle } from '@capacitor/core';

@Component({
  selector: 'map-generic',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss']
})
export class MapComponent implements OnInit, OnDestroy {
  @Input() id = "default-id" //html id
  @Input() class = "" //css class
  @Input() style = {} //css style
  @Input() mapTypeStyle = "mapbox://styles/mstfcinar/clav3s3no003z15mkm7k7yl21" //map type
  @Input() center: { lat, lng } = null
  @Input() zoom: number = 3
  keyboardListener: Promise<PluginListenerHandle> & PluginListenerHandle | Promise<void>
  @Output() loaded: EventEmitter<any> = new EventEmitter();

  map
  private mapService: MapService = new MapService()
  constructor(private changeDet: ChangeDetectorRef) { }
  ngOnDestroy(): void {
    this.mapService.destroyMap(this.map);
    this.keyboardListener = undefined
  }

  ngOnInit() {
    let style = 'mapbox://styles/mapbox/satellite-v9';// 'mapbox://styles/mapbox/satellite-v';
    // "mapTest", 10, style, { lat: 38.229682, lng: 27.975945 }
    this.mapService.buildMap({
      mapId: this.id, style: this.mapTypeStyle, center: this.center, zoom: this.zoom, onLoadCallback: (ev) => {
        // this.loadCallback(ev)
      }
    }).subscribe(response => {
      this.map = response
      this.map.on("load", (ev) => {
        this.map = this.mapService.resizeMap(this.map);
        window[this.id] = this.map;
        // this.map = this.mapService.mapAddFullscreenCtrl(this.map)
        this.loaded.emit(this.map);
        // this.mapService.followMyLocation({ map: this.map, icon: null, id: "home-map-me" })
        if (typeof this.keyboardListener === 'undefined')
          this.keyboardListener = KeyboardActionsService.GetCloseListener((e) => {
            this.changeDet.detectChanges()
            if (this.map)
              this.mapService.resizeMap(this.map)
          })
      })
    })
  }

  ionViewWillEnter() {

  }

  public loadCallback(ev) {
    this.map = this.mapService.resizeMap(this.map);
    // this.map = this.mapService.mapAddFullscreenCtrl(this.map)
    this.loaded.emit(ev);
  }

  public addDraw() {
    this.mapService.addDrawControls(this.map, this, (ev) => {
    })
  }

}
